<h2 mat-dialog-title>Confirm Order</h2>
<div mat-dialog-content class="form">
  <mat-form-field>
    <input matInput id="email" [formControl]="email" placeholder="email">
    <div *ngIf="email.invalid && (email.dirty || email.touched)"
         class="alert alert-danger">
      <mat-error *ngIf="email.errors.required">
        Name is required.
      </mat-error>
      <mat-error *ngIf="email.errors.email">
        needs to be a valid email address
      </mat-error>
    </div>
  </mat-form-field>
  <div *ngIf="completed$ | async">
    order has been placed
  </div>
  <mat-error *ngIf="error$ | async">
    An error occurred
  </mat-error>
</div>

<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Cancel</button>
  <button mat-button color='primary' class="order-button" (click)="order()" [disabled]="busy$ | async">Order</button>
</div>
